// @ts-expect-error Type definitions not specified for css preamble
import "@tractie/components/styles";
import { loadDefaultFeedbackMessages } from "@tractie/components";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { BaseWrapper } from "@shared/BaseWrapper.tsx";
import { KnopHttpClientProvider } from "@opstel/contexts/knopClient/KnopHttpClientProvider.tsx";
import { AuthenticationProvider } from "@shared/auth/providers/AuthenticationProvider.tsx";
import { App } from "@shared/App.tsx";
import { ReactAppProvider } from "@opstel/reactApp/ReactAppProvider";
import { config } from "@shared/envVariables";
import { initializeDatadog } from "@shared/telemetry/datadog";

initializeDatadog(config.datadog);
loadDefaultFeedbackMessages();

ReactDOM.createRoot(document.getElementById("knop")!).render(
  <BaseWrapper>
    <BrowserRouter>
      <AuthenticationProvider>
        <ReactAppProvider>
          <KnopHttpClientProvider>
            <App />
          </KnopHttpClientProvider>
        </ReactAppProvider>
      </AuthenticationProvider>
    </BrowserRouter>
  </BaseWrapper>,
);
